import { ConfirmModalComponent } from './../../shared/confirm-modal/confirm-modal.component';
import { FloorPlan } from './../../model/floorplan.model';
import { DatiUIU } from './../../model/dati-uiu.model';
import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { paramsSeparator } from 'src/app/shared/utils';
import { AppState } from 'src/app/app.state';
import { Store } from '@ngrx/store';
import * as ImagePlanActions from '../../store/actions/image.actions';
import * as FloorPlanActions from '../../store/actions/floorplan.actions';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-left-panel',
  templateUrl: './left-panel.component.html',
  styleUrls: ['./left-panel.component.scss']
})
export class LeftPanelComponent implements OnInit, AfterViewInit {

  @Output() onSelectFile: EventEmitter<string> = new EventEmitter();

  methodDraw: any;
  scrollHeight: string = '120px';
  planimetrie: string;
  currentShowingPlan: string;
  selectedFloorPlan: any;
  jsonLoaded: boolean = false;

  lpColumns = [
    {field: '', header: ''}
  ];

  imTableData: any[] = [];

  lpTableData: any[] = [];

  dtTableData: any[] = [];

  constructor(
    private store: Store<AppState>,
    private dialogService: DialogService
  ) { 
    this.planimetrie = localStorage.getItem('planimetrie');
  }

  ngOnInit() {
    this.methodDraw = window['methodDraw'];

    const filenames = this.planimetrie.split(paramsSeparator);
    filenames.forEach(name => {
      this.lpTableData.push({
        nome: name
      })
    });

    this.store.select('datiUIU').subscribe((val: DatiUIU) => {
      if (val) {
        this.imTableData.push({label: 'Sezione: ', value: val.sezione});
        this.imTableData.push({label: 'Foglio:', value: val.foglio});
        this.imTableData.push({label: 'Numero:', value: val.numero});
        this.imTableData.push({label: 'Subalterno:', value: val.subalterno});
        this.imTableData.push({label: 'Sup. dpr 138/98:', value: val.superficieDpr});
      }
    });

    this.store.select('floorPlan').subscribe((val: FloorPlan) => {
      if (val && val.testata) {
        setTimeout(() => {
          const workareaHeight = document.getElementById('workarea').offsetHeight;
          if (workareaHeight > 0) {
            this.scrollHeight = (workareaHeight/100) * 28 + 'px';
          }
          this.dtTableData = [];
          this.dtTableData.push({label: 'Formato Immagine', value: val.testata['formato immagine']});
          this.dtTableData.push({label: 'Formato Foglio', value: val.testata['formato foglio']});
          this.dtTableData.push({label: 'Docfa', value: val.testata.docfa ? 'Si' : 'No'});
          this.dtTableData.push({label: 'Vani norm.', value: val.testata.rooms_ok});
          this.dtTableData.push({label: 'Vani non norm.', value: val.testata.rooms_unk});
          this.dtTableData.push({label: 'Vani senza descr.', value: val.testata.rooms_blank});
          if (val.testata.error) {
            this.dtTableData.push({label: 'Errore', value: val.testata.error ? val.testata.error : '-'});
          }
          this.jsonLoaded = true;
        }, 1500);
      }
    });

    this.onSelectFile.emit(filenames[0]);
    this.store.dispatch(new ImagePlanActions.GetImage(filenames[0]));
    this.selectedFloorPlan = this.lpTableData[0];
    this.currentShowingPlan = this.lpTableData[0].nome;
  }

  ngAfterViewInit() {
    this.onSelectFile.emit(this.lpTableData[0].nome);
  }

  onSelectFloorplan(evt) {
    const row = evt.data;
    const planModified = this.methodDraw.canvas.undoMgr.getUndoStackSize() > 0 ? true : false;
    if (row.nome !== this.currentShowingPlan) {
      if (planModified) {
        const ref = this.dialogService.open(ConfirmModalComponent, {
          header: 'Attenzione!',
          width: '20%',
          closable: false,
          data: {
            confirmLabel: 'Procedi',
            rejectLabel: 'Annulla',
            message: 'Sono presenti modifiche non salvate sulla planimetria corrente: si vuole procedere comunque? Le modifiche verranno perse.'
          }
        });
        ref.onClose.subscribe(val => {
          if (val) {
            this.onSelectFile.emit(row.nome);
            this.currentShowingPlan = row.nome;
            this.jsonLoaded = false;
            this.cleanRaster();
            this.store.dispatch(new FloorPlanActions.SetFloorplan(new FloorPlan()));
            this.store.dispatch(new ImagePlanActions.GetImage(row.nome));
          } else {
            this.selectedFloorPlan = this.lpTableData.find(val => val.nome === this.currentShowingPlan);
          }
        });
      } else {
        this.onSelectFile.emit(row.nome);
        this.currentShowingPlan = row.nome;
        this.jsonLoaded = false;
        this.cleanRaster();
        this.store.dispatch(new FloorPlanActions.SetFloorplan(new FloorPlan()));
        this.store.dispatch(new ImagePlanActions.GetImage(row.nome));
      }
    }
  }

  onUnselectFloorplan(evt) {
    const row = evt.data;
    this.currentShowingPlan = row.nome;
    this.selectedFloorPlan = row;
  }  

  cleanRaster() {
    this.methodDraw.canvas.clearSelection();
    const tmpRect = document.getElementById('currRect');
    const tmpPath = document.getElementById('currPath');
    if (tmpRect) {
      tmpRect.remove();
    }
    if (tmpPath) {
      tmpPath.remove();
    }
  }

}
